class Charpstar3d {
  CONFIGURATOR_EVENTS = ["configurator:model-clicked", "configurator:model-loaded", "configurator:model-delete"];
  REFRESH_CART = true;
  PREORDER_STATUS = true;
  PREORDER_SHIPPING_PLACEHOLDER = "{{shippingDate}}";
  charpstAR;
  products;
  configurator;
  translations;
  colors;
  shopFormat;
  config;
  preorderData = { settings: null, products: [] };
  lastAddedModul = null;
  cartProducts = [];
  #temporaryCartProducts = [];
  accessoryVariants = [];

  get temporaryCartProducts() {
    return this.#temporaryCartProducts;
  }

  set temporaryCartProducts(newValue) {
    const oldValue = this.#temporaryCartProducts;
    this.#temporaryCartProducts = newValue;
    this.onTemporaryCartProductsChanged(newValue, oldValue);
  }

  /**
   * Observer called whenever temporaryCartProducts is reassigned.
   * Override or extend this method to react to changes.
   * @param {Array} newValue - The new array value
   * @param {Array} oldValue - The previous array value
   */
  onTemporaryCartProductsChanged(newValue, oldValue) {
    //console.log('[temporaryCartProducts changed]', { oldValue, newValue });
    const matchedBundles = this.findMatchingBundles();
    //console.log('[Matched Bundles]', matchedBundles);

    if (matchedBundles && matchedBundles.length > 0) {
      const bestMatch = matchedBundles[0];
      //console.log(bestMatch)

      this.bundle = bestMatch.bundle;
      // Attach the specific items that satisfied this bundle so downstream logic doesn't have to re-evaluate
      this.bundle.matchedItems = bestMatch.matchedItems;

      this.showBundlePopup(this.bundle);
    } else {
      this.closeBundlePopup();
    }
  }

  showBundlePopup = (bundle) => {
    // 1. Group the exact items that matched this bundle to display their quantities
    const relevantProducts = bundle.matchedItems || [];
    const uniqueMap = new Map();

    relevantProducts.forEach(p => {
      // Use variant_id + title as a unique key for grouping visual rows
      const key = String(p.variant_id) + '-' + (p.title || '');
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, { ...p, qty: 1 });
      } else {
        uniqueMap.get(key).qty += 1;
      }
    });

    const uniqueProducts = Array.from(uniqueMap.values());

    const itemsHtml = uniqueProducts.map(p => `
      <div class="bundle-popup__cart-item cart-item">
        <div class="cart-item-image">
          ${p.imageUrl ? `<img src="${p.imageUrl}" alt="${p.name}">` : ''}
          <div class="item-count">${p.qty}</div>
        </div>
        <div class="cart-item-details">
          <div class="item-name">${p.name}</div>
          <div class="item-specs">${p.title}</div>
        </div>
        <div class="item-price">
          x${p.qty}
          <span class="bundle-popup__item-unit">${p.formattedPrice}</span>
        </div>
      </div>
    `).join('');

    const html = `
      <div class="bundle-popup__overlay" id="bundle-popup-overlay">
        <div class="bundle-popup" id="bundle-popup">
          <button class="bundle-popup__close" id="bundle-popup-close" aria-label="Close">
            <svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line y1="-0.75" x2="16.4487" y2="-0.75" transform="matrix(0.729537 0.683941 -0.729537 0.683941 0 1.05225)" stroke="currentColor" stroke-width="1.5"/>
              <line y1="-0.75" x2="16.4487" y2="-0.75" transform="matrix(-0.729537 0.683941 -0.729537 -0.683941 12 0)" stroke="currentColor" stroke-width="1.5"/>
            </svg>
          </button>
          <div class="bundle-popup__header">
            <div class="bundle-popup__badge">${this.translations.bundlePopupTitle}</div>
            <h3 class="bundle-popup__title">${bundle.title}</h3>
          </div>
          <div class="bundle-popup__price-row">
            <span class="bundle-popup__price-label">${this.translations.bundlePopupPrice}</span>
            <span class="bundle-popup__price">${this.formatMoney(bundle.price, this.shopFormat.moneyFormat)}</span>
          </div>
          <div class="bundle-popup__items">${itemsHtml}</div>
          <div class="bundle-popup__actions">
            <button class="bundle-popup__btn bundle-popup__btn--primary" id="bundle-popup-confirm">${this.translations.bundlePopupConfirm}</button>
            <button class="bundle-popup__btn bundle-popup__btn--secondary" id="bundle-popup-dismiss">${this.translations.bundlePopupDismiss}</button>
          </div>
        </div>
      </div>
    `;

    // Remove any existing popup first
    this.closeBundlePopup();
    document.querySelector('.charpstar-configurator').insertAdjacentHTML('beforeend', html);

    document.getElementById('bundle-popup-close').addEventListener('click', () => this.closeBundlePopup());
    document.getElementById('bundle-popup-dismiss').addEventListener('click', () => this.closeBundlePopup());
    document.getElementById('bundle-popup-overlay').addEventListener('click', (e) => {
      if (e.target.id === 'bundle-popup-overlay') this.closeBundlePopup();
    });
    document.getElementById('bundle-popup-confirm').addEventListener('click', () => {
      //console.log('[Bundle] User confirmed bundle:', bundle);

      // 1. Generate a random 8-character alphanumeric bundle ID
      const bundleId = Math.random().toString(36).slice(2, 10);
      const bundleProductId = bundle.variant_id; // the bundle product's own variant_id
      const bundleProduct = bundle.product

      // 2. We already know EXACTLY which temporaryCartProducts triggered this bundle!
      const matchedTempItems = bundle.matchedItems || [];

      // 3. Stamp bundle_id + bundle_product_id + bundle_price onto the exact temporaryCartProducts items
      //    (mutate in-place to avoid re-triggering observer during assignment)
      matchedTempItems.forEach(item => {
        item.bundle_id = bundleId;
        item.bundle_product_id = bundleProductId;
        item.bundle_price = bundle.price;
      });

      // 4. Stamp bundle info onto the equivalent elements in cartProducts
      // Match by finding cartProducts with same variant_id that aren't bundled yet
      matchedTempItems.forEach(matchedTemp => {
        const matchingCartProduct = this.cartProducts.find(p => !p.bundle_id && String(p.id) === String(matchedTemp.variant_id));
        if (matchingCartProduct) {
          this.getPreorderData(bundleProduct).then((preorderData) => {
            //console.log('[PREORDER DATA]: ', preorderData)
              let isPreorderProduct = false;
              let properties = {};
              let sellingPlan = null;
              let shippingDate = null;

              properties["_configurator"] = "true";

              if (preorderData !== null && preorderData.product.variants[bundleProductId]) {
                const preorderVariant = preorderData.product.variants[bundleProductId];
                if (preorderVariant.isPOEnabled) {
                  isPreorderProduct = true;
                  shippingDate = preorderVariant.config.shippingDate.date;
                  if (this.PREORDER_STATUS) {
                    sellingPlan = preorderVariant.config.sellingPlan;
                    properties[this.preorderData.settings.cart.labelText.key] =
                      this.preorderData.settings.cart.labelText.value.replace(
                        this.PREORDER_SHIPPING_PLACEHOLDER,
                        this.timestampToDate(shippingDate),
                      );
                  }
                }
              }
              matchingCartProduct.bundle_selling_plan = sellingPlan;
              matchingCartProduct.bundle_product_properties = properties;
              matchedTemp.bundle_selling_plan = sellingPlan;
              matchedTemp.bundle_product_properties = properties;
          })
          matchingCartProduct.bundle_id = bundleId;
          matchingCartProduct.bundle_product_id = bundleProductId;
          matchingCartProduct.bundle_price = bundle.price;
        }
      });

      // 5. Update the cart HTML: wrap matched .cart-item elements in a .cart-item-bundle div
      const cartItemsEl = this.config.cartItems;
      const allCartItemEls = [...cartItemsEl.querySelectorAll('.cart-item')].filter(el => el.closest('.cart-item-bundle') === null);

      const matchedCartItemEls = [];
      matchedTempItems.forEach(matchedTemp => {
        // Find the first unassigned DOM element matching this variant_id
        const idx = allCartItemEls.findIndex(el => String(el.dataset.variantId) === String(matchedTemp.variant_id));
        if (idx !== -1) {
          matchedCartItemEls.push(allCartItemEls.splice(idx, 1)[0]);
        }
      });

      if (matchedCartItemEls.length > 0) {
        // Create the wrapper only once and move all matched items into it
        const wrapper = document.createElement('div');
        wrapper.className = 'cart-item-bundle';
        wrapper.dataset.bundleId = bundleId;

        // Create an info header for the bundle
        const bundleHeader = document.createElement('div');
        bundleHeader.className = 'cart-item-bundle-header';
        bundleHeader.innerHTML = `
          <div class="bundle-title"><strong>${bundle.title}</strong></div>
          <div class="bundle-price"><strong>${bundle.formattedPrice}</strong> ${bundle.compare_at_price > 0 && bundle.price !== bundle.compare_at_price ? `<span class="item-old-price">${this.formatMoney(bundle.compare_at_price, this.shopFormat.moneyFormat)}</span>` : ''}</div>
        `;

        wrapper.appendChild(bundleHeader);

        // Insert the wrapper before the first matched item
        matchedCartItemEls[0].before(wrapper);

        // Move each matched item into the wrapper
        matchedCartItemEls.forEach(el => wrapper.appendChild(el));
      }

      //console.log('[Bundle] bundle_id assigned:', bundleId, '| bundle_product_id:', bundleProductId);
      this.calculateTotalPrice();
      this.closeBundlePopup();
    });
    document.getElementById('bundle-popup-overlay').classList.add('active')
  }

  closeBundlePopup = () => {
    const existing = document.getElementById('bundle-popup-overlay');
    if (existing) existing.remove();
  }

  constructor(charpstAR, products, configurator, translations, colors, shopFormat) {
    this.charpstAR = charpstAR;
    this.products = products;
    this.configurator = configurator;
    this.translations = translations;
    this.colors = colors;
    this.shopFormat = shopFormat;

    this.config = {
      colorSection: this.configurator.querySelector(".color-section"),
      colorContainer: this.configurator.querySelector(".color-section .color-options"),
      selectedColor: this.configurator.querySelector(".selected-color"),
      closeBtn: this.configurator.querySelector(".selected-color .color-options-close"),
      moduleSection: this.configurator.querySelector(".module-options"),
      moduleOptions: this.configurator.querySelectorAll(".module-options .module-option"),
      accessorySections: {
        accessory: this.configurator.querySelector(".accessories-section"),
        kitchen_accessory: this.configurator.querySelector(".kitchen-accessories-section"),
      },
      sectionTitles: {
        products: this.configurator.querySelector(".section-title.products"),
        accessories: this.configurator.querySelector(".section-title.accessories"),
        kitchen_accessories: this.configurator.querySelector(".section-title.kitchen-accessories"),
      },
      defaultSelectedColorHtml: this.configurator.querySelector(".selected-color").innerHTML,
      accessoryOverlay: this.configurator.querySelector(".accessory-overlay"),
      accessoryPopup: this.configurator.querySelector(".accessory-popup"),
      addToCartBtn: this.configurator.querySelector(".button.product__add-cart"),
      cartItems: this.configurator.querySelector(".cart-items"),
      totalSection: this.configurator.querySelector(".total-section"),
      allColorSection: this.configurator.querySelector(".all-colors-section"),
      allColorSectionSelectedColor: this.configurator.querySelector(".all-colors-section .selected-color"),
      shareButton: this.configurator.querySelector(".checkout-button-wrapper #share-button"),
    };
  }

  init = async () => {
    try {
      await this.charpstAR.init();
      const configData = await this.loadConfigFromURL()
      await this.loadPreorder(true);
      await this.removeConfiguratorProducts();

      window.DangardenTheme.refreshCart(false);

      if (!configData) {
        await this.restoreSessionData();
      } else {
        await this.restoreSessionData(configData, true);
      }


    } catch (error) {
      console.error("Charpstar AR initialization failed:", error);
    }
  };

  addAllColorOptions = () => {
    let self = this;
    const product = this.products["8526635041110"];

    const productVariants = product.variants;

    let html = "";
    productVariants.forEach((variant) => {
      html += this.buildColor(variant);
    });

    this.config.allColorSection.querySelector(".color-options").insertAdjacentHTML("afterbegin", html);

    this.config.allColorSection.querySelectorAll(".color-option").forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.clearCartMessage();

        const colorName = self.getColor(item.querySelector(".color-name").innerHTML);
        self.config.allColorSection.querySelectorAll(".color-option").forEach((item) => {
          item.classList.remove("active");
        });
        item.classList.add("active");

        self.charpstAR.setSceneColor(self.colors[colorName]);

        self.cartProducts.forEach((prod) => {
          if (prod.modulId) {
            const variant = self.products[parseInt(prod.productId)].variants.find(
              (v) => v.color.trim() === item.querySelector(".color-name").innerHTML.trim(),
            );
            if (typeof variant !== "undefined") {
              self.updateProductInCart(variant, prod.modulId, false, item.querySelector(".color-name").innerHTML.trim());
            }
          }
        });

        document.getElementById("change-all-colors").dispatchEvent(new Event("change"));

        self.config.allColorSectionSelectedColor.querySelector(".color-circle").innerHTML =
          item.querySelector(".color-circle").innerHTML;
        self.config.allColorSectionSelectedColor.querySelector(".color-name .color").innerHTML =
          item.querySelector(".color-name").innerHTML;
        self.config.allColorSectionSelectedColor.classList.toggle("active", false);
        self.config.allColorSection.querySelector(".color-options").classList.toggle("active", false);
      });
    });
  };

  addEventListeners = () => {
    let self = this;

    document.getElementById("change-all-colors").addEventListener("change", function () {
      if (this.checked) {
        self.config.allColorSection.classList.add("active");
      } else {
        self.config.allColorSection.classList.remove("active");
      }
    });
    this.config.selectedColor.addEventListener("click", async (e) => {
      if (e.target.classList.contains("color-options-close")) {
        self.config.colorContainer.classList.remove("active");
        self.config.selectedColor.classList.remove("active");
        return;
      }

      const isActive = self.config.selectedColor.classList.contains("active");
      self.config.selectedColor.classList.toggle("active", !isActive);
      self.config.colorContainer.classList.toggle("active", !isActive);
    });

    this.config.allColorSectionSelectedColor.addEventListener("click", async (e) => {
      if (e.target.classList.contains("color-options-close")) {
        self.config.allColorSection.querySelector(".color-options").classList.remove("active");
        self.config.allColorSectionSelectedColor.classList.remove("active");
        return;
      }

      const isActive = self.config.allColorSectionSelectedColor.classList.contains("active");
      self.config.allColorSectionSelectedColor.classList.toggle("active", !isActive);
      self.config.allColorSection.querySelector(".color-options").classList.toggle("active", !isActive);
    });

    this.config.addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      self.addToCart();
    });
    this.configurator.addEventListener("model-loaded", async (e) => {
      if (e.detail.id.includes("OL-2504SF-A-OD")) {
        return;
      }

      /*self.charpstAR.toggleMesh("OL-2504SF-A-OD", false);
      self.charpstAR.toggleMesh("NFKAMADOBEI", false);
      self.charpstAR.toggleMesh("NFKAMADOBK", false);*/

      if (self.lastAddedModul === null) {
        return;
      }

      self.lastAddedModul.key = e.detail.key;

      const product = self.lastAddedModul.product;
      const productId = self.lastAddedModul.productId;

      if (product.accessories.length !== 0) {

        product.accessories.forEach((accessory) => {
          let sku = accessory.sku;
          sku = sku.replace(/-[^-]*$/, "");
          //self.charpstAR.toggleMesh(sku, false)
        });
      }

      const productVariants = self.lastAddedModul.product.variants;
      let productVariant = productVariants.find((variant) => variant.selected === 1);
      productVariant["modulId"] = e.detail.key;

      self.removeColorOptions();

      let html = "";
      productVariants.forEach((variant) => {
        html += self.buildColor(variant);
      });

      self.config.colorContainer.insertAdjacentHTML("afterbegin", html);

      await this.loadPreorder();

      let hasAccessories = product.accessories.length;
      let hasKitchenAccessories = product.kitchen_accessories.length;

      html = "";
      html += self.buildAccessory([], false);
      if (hasAccessories) {
        product.accessories.forEach((accessory) => {
          html += self.buildAccessory(accessory, true, productId, e.detail.key);
        });
      }

      self.config.accessorySections.accessory.innerHTML = "";
      self.config.accessorySections.accessory.insertAdjacentHTML("afterbegin", html);

      html = "";
      if (hasKitchenAccessories) {
        product.kitchen_accessories.forEach((accessory) => {
          html += self.buildAccessory(accessory, true, productId, e.detail.key);
        });

        self.config.accessorySections.kitchen_accessory.innerHTML = "";
        self.config.accessorySections.kitchen_accessory.insertAdjacentHTML("afterbegin", html);
      }

      if (hasAccessories || hasKitchenAccessories) {
        self.config.moduleSection.classList.add("hidden");
        self.config.sectionTitles.products.classList.add("hidden");
        self.config.accessorySections.accessory.classList.add("active");
        self.config.sectionTitles.accessories.classList.remove("hidden");
        self.config.accessorySections.accessory.querySelector(".back-button").addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          self.resetToModules();
        });

        if (hasKitchenAccessories) {
          self.config.accessorySections.kitchen_accessory.classList.add("active");
          self.config.sectionTitles.kitchen_accessories.classList.remove("hidden");
        }
      }

      self.addToCartProduct(productVariant);

      self.config.colorSection.classList.add("active");
      const colorOptions = self.config.colorContainer.querySelectorAll(".color-option");
      colorOptions.forEach((colorOption) => self.addColorEventListener(colorOption, productVariants, productId));

      if (hasAccessories || hasKitchenAccessories) {
        self.addAccessoryEventListeners();
      }
    });

    this.configurator.addEventListener("model-click", (e) => {
      let self = this;
      const key = e.detail.key;

      const cartProduct = self.config.cartItems.querySelector('.cart-item[data-modul-id="' + key + '"]');

      if (cartProduct !== null) {
        const productId = cartProduct.dataset.defaultId;

        self.config.moduleSection.classList.remove("hidden");
        self.config.sectionTitles.products.classList.remove("hidden");
        self.config.sectionTitles.accessories.classList.add("hidden");
        self.config.sectionTitles.kitchen_accessories.classList.add("hidden");
        self.config.colorSection.classList.remove("active");
        self.config.accessorySections.accessory.classList.remove("active");
        self.config.accessorySections.kitchen_accessory.classList.remove("active");
        self.config.moduleOptions.forEach((option) => {
          option.classList.remove("active");
          if (option.dataset.productId === productId) {
            option.dispatchEvent(new CustomEvent("click", { detail: { key: e.detail.key, update: true } }));
          }
        });
      }
    });
    this.configurator.addEventListener("model-delete", (e) => {
      this.clearCartMessage();
      const cartProduct = self.config.cartItems.querySelector('.cart-item[data-modul-id="' + e.detail.key + '"]');
      if (cartProduct === null) {
        return;
      }

      self.removeProductFromCart(cartProduct, null);

      cartProduct.remove();
    });

    this.configurator.addEventListener("background-click", (e) => {
      self.resetToModules();
    });

    this.config.shareButton.addEventListener("click", (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (this.config.shareButton.classList.contains('disabled')) {
        return;
      }

      document.querySelector('.charpstar-configurator-overlay').classList.remove('hidden')
      document.querySelector('.charpstar-configurator-overlay .charpstar-send-wrapper').classList.remove('hidden')

    })

    document.querySelector('.charpstar-configurator-overlay .charpstar-send-wrapper .send-close').addEventListener('click', (e) => {
      document.querySelector('.charpstar-configurator-overlay').classList.add('hidden')
      document.querySelector('.charpstar-configurator-overlay .charpstar-send-wrapper').classList.add('hidden')
    })

    document.querySelector('.charpstar-configurator-overlay .charpstar-send-wrapper .send-button-email').addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      const input = document.querySelector('.charpstar-configurator-overlay .charpstar-send-wrapper input')

      const email = input.value.trim()
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      if (!email || !emailRegex.test(email)) {
        input.classList.add('error')

        return;
      }

      this.generateShareLink().then(r => {
        const subject = self.translations.shareEmailSubject
        const body = self.translations.shareEmailBodyText + ' ' + r
        window.open(`mailto:${encodeURIComponent(input.value)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`, '_blank')
      })
    })

    document.querySelector('.charpstar-configurator-overlay .charpstar-send-wrapper input').addEventListener('input', (e) => {
      input.classList.remove('error')
    })

    document.querySelector('.charpstar-configurator-overlay .charpstar-send-wrapper .send-button-copy').addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      this.generateShareLink().then(r => {
        navigator.clipboard.writeText(r).then(() => {
          document.querySelector('.charpstar-configurator-overlay .charpstar-send-wrapper .send-button-copy > span').innerHTML = self.translations.shareEmailCopySuccess

          setTimeout(() => {
            document.querySelector('.charpstar-configurator-overlay .charpstar-send-wrapper .send-button-copy > span').innerHTML = self.translations.shareEmailCopyButton;
          }, 5000);
          /* Resolved - text copied to clipboard successfully */
        }, () => {
          console.error('Failed to copy');
          /* Rejected - text failed to copy to the clipboard */
        });
      })
    })

    this.addModulEventListener();
  };

  addModulEventListener = () => {
    let self = this;
    this.config.moduleOptions.forEach((item) => {
      item.addEventListener("click", async (e) => {
        this.clearCartMessage();
        if (item.classList.contains("disabled")) {
          return;
        }

        const productId = item.dataset.productId;
        const product = self.products[productId];

        let sku = product.sku.replace(/-[^-]*$/, "");
        product.variants.sort((a, b) => {
          return (b.selected === 1 ? 1 : 0) - (a.selected === 1 ? 1 : 0);
        });

        self.config.selectedColor.classList.remove("active");
        self.config.colorContainer.classList.remove("active");
        self.removeActiveClass(self.config.moduleOptions, true);

        if (typeof e.detail.update !== "undefined" && e.detail.update) {
          const productVariants = product.variants;
          let productVariant = productVariants.find((variant) => variant.selected === 1);
          productVariant["modulId"] = e.detail.key;

          self.removeColorOptions();

          let html = "";
          productVariants.forEach((variant) => {
            html += self.buildColor(variant);
          });

          self.config.colorContainer.insertAdjacentHTML("afterbegin", html);

          await this.loadPreorder();

          let hasAccessories = product.accessories.length;
          let hasKitchenAccessories = product.kitchen_accessories.length;

          self.config.accessorySections.accessory.innerHTML = "";
          self.config.accessorySections.kitchen_accessory.innerHTML = "";
          html = "";
          html += self.buildAccessory([], false);
          if (hasAccessories) {
            product.accessories.forEach((accessory) => {
              html += self.buildAccessory(accessory, true, productId, e.detail.key);
            });
          }
          self.config.accessorySections.accessory.innerHTML = "";
          self.config.accessorySections.accessory.insertAdjacentHTML("afterbegin", html);

          html = "";
          if (hasKitchenAccessories) {
            product.kitchen_accessories.forEach((accessory) => {
              html += self.buildAccessory(accessory, true, productId, e.detail.key);
            });

            self.config.accessorySections.kitchen_accessory.innerHTML = "";
            self.config.accessorySections.kitchen_accessory.insertAdjacentHTML("afterbegin", html);
          }

          if (hasAccessories || hasKitchenAccessories) {
            self.config.moduleSection.classList.add("hidden");
            self.config.sectionTitles.products.classList.add("hidden");
          }

          if (hasAccessories || (!hasAccessories && hasKitchenAccessories)) {
            self.config.accessorySections.accessory.classList.add("active");
            self.config.sectionTitles.accessories.classList.remove("hidden");
            self.config.accessorySections.accessory.querySelector(".back-button").addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();

              self.resetToModules();
            });
          }

          if (hasKitchenAccessories) {
            self.config.accessorySections.kitchen_accessory.classList.add("active");
            self.config.sectionTitles.kitchen_accessories.classList.remove("hidden");
          }

          self.config.colorSection.classList.add("active");
          const colorOptions = self.config.colorContainer.querySelectorAll(".color-option");
          colorOptions.forEach((colorOption) =>
            self.addColorEventListener(colorOption, productVariants, productId, e.detail.key),
          );

          if (hasAccessories || hasKitchenAccessories) {
            self.addAccessoryEventListeners();
          }
        } else {
          self.lastAddedModul = null;
          self.modelLoaded = false;
        }

        if (typeof e.detail.key === "undefined") {
          self.lastAddedModul = {
            item: item,
            product: product,
            sku: sku,
            key: null,
            productId: productId,
          };

          self.loadModel(sku);
        }
        item.classList.add("active");
      });
    });
  };

  // Color event listener
  addColorEventListener = (item, productVariants, productId, moduleId = "") => {
    let self = this;
    item.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (item.classList.contains("disabled")) {
        return;
      }

      this.clearCartMessage();

      const colorOptions = self.config.colorContainer.querySelectorAll(".color-option");

      colorOptions.forEach((color) => {
        color.classList.remove("active");
      });

      const variantId = item.dataset.variantId;
      let variant = productVariants.find((variant) => variant.variant_id === variantId);
      variant["productId"] = productId;
      self.applySelectedColor(
        self.config.selectedColor,
        item.querySelector(".color-name").innerHTML,
        item.querySelector(".color-circle").querySelector("img").src,
        item.querySelector(".color-circle").querySelector("img").alt,
      );
      self.config.selectedColor.classList.remove("active");
      self.config.colorContainer.classList.remove("active");
      item.classList.add("active");
      if (moduleId) {
        const preOrderStatus =
          item.querySelector(".timesact-preorder-description") &&
          item.querySelector(".timesact-preorder-description").innerHTML.trim() !== "";
        this.updateProductInCart(variant, moduleId, preOrderStatus, item.querySelector(".color-name").innerHTML.trim());
      } else {
        this.updateProductInCart(
          variant,
          self.lastAddedModul.key,
          false,
          item.querySelector(".color-name").innerHTML.trim(),
        );
      }
    });
  };

  // Returns the length of the common prefix between two strings
  commonPrefixLength = (a, b) => {
    let i = 0;
    while (i < a.length && i < b.length && a[i] === b[i]) i++;
    return i;
  }

  // Two SKUs are "siblings" if they share ≥75% of the shorter SKU's length as a prefix
  areSiblingSkus = (skuA, skuB) => {
    const prefixLen = this.commonPrefixLength(skuA, skuB);
    const threshold = Math.min(skuA.length, skuB.length) * 0.75;
    return prefixLen >= threshold;
  }

  addAccessoryEventListeners = () => {
    let self = this;
    const accessories = self.config.accessorySections.accessory.querySelectorAll(
      ".module-option:not(.back-button)",
    );
    if (accessories.length !== 0) {
      accessories.forEach((accessory) => {
        accessory.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (accessory.classList.contains('disabled')) {
            return;
          }

          /*if (accessory.dataset.sku.includes("OL-2504SF-A-OD")) {
            if (accessory.dataset.toggle === "true") {
              return;
            }

            accessory.classList.add("active");

            // Initialize to 'false' if undefined
            accessory.dataset.toggle = accessory.dataset.toggle || "false";

            // Toggle
            accessory.dataset.toggle = accessory.dataset.toggle === "true" ? "false" : "true";

            const toggle = accessory.dataset.toggle === "true";

            switch (self.charpstAR.toggleMesh(accessory.dataset.sku, toggle)) {
              case 1:
                let variant = self.findAccessoryByItem(accessory, false);

                if (!variant) return;

                variant["product_id"] = variant.id;
                variant["selling_plan"] = null;
                variant["properties"] = {
                  _configurator: "true",
                };
                variant["default_product_id"] = accessory.dataset.parentId;
                if (accessory.dataset.parentModulId) {
                  variant["parent_module_id"] = accessory.dataset.parentModulId;
                }

                self.addToCartProduct(variant, true).then(() => {
                  const childItem = self.config.cartItems.querySelector('.cart-item[data-parent-modul-id="' + accessory.dataset.parentModulId + '"]');

                  const colorData = document.querySelector(".charpstar-configurator #charpstar-configurator-actions .color-section>.selected-color");
                  const color = colorData.querySelector(".color-name .color").innerHTML.trim();

                  if (childItem !== null && color !== self.translations.choose) {
                    const accVar = self.products[accessory.dataset.parentId]["accessories"].find(
                      (item) => item.product_id == accessory.dataset.productId,
                    );

                    if (!accVar) {
                      return;
                    }

                    const accVarVariants = accVar.variants;

                    const colorVariant = accVarVariants.find((i) => i.color == color);
                    if (!colorVariant) {
                      return;
                    }

                    let properties = {};
                    let sellingPlan = null;
                    let shippingDate = null;
                    properties["_configurator"] = "true";

                    const childImage = childItem.querySelector(".cart-item-image img");
                    childItem.dataset.productId = colorVariant.product_id;
                    childItem.dataset.variantId = colorVariant.variant_id;
                    childImage.src = colorVariant.featured_image;
                    childImage.alt = colorVariant.name + " " + colorVariant.title;
                    childImage.title = colorVariant.name + " " + colorVariant.title;
                    childItem.querySelector(".cart-item-details .item-name").innerHTML = colorVariant.name;
                    childItem.querySelector(".cart-item-details .item-specs").innerHTML = colorVariant.title;

                    self.cartProducts.forEach((product) => {
                      if (product.parentModulId === accessory.dataset.parentModulId) {
                        product.id = colorVariant.variant_id;
                        product.price = colorVariant.price;
                        product.productId = colorVariant.product_id;
                        product.isPreorder = false;
                        product.properties = properties;
                        product.selling_plan = sellingPlan && this.PREORDER_STATUS ? parseInt(sellingPlan) : null;
                      }
                    });

                    self.temporaryCartProducts.forEach((product) => {
                      if (product.parent_module_id === accessory.dataset.parentModulId) {
                        product.variant_id = colorVariant.variant_id;
                        product.product_id = colorVariant.product_id;
                        product.sku = colorVariant.sku.replace(/-[^-]*$/, "");
                        product.isToggle = childItem.dataset.isToggle;
                        product.imageUrl = colorVariant.featured_image;
                        product.name = colorVariant.name;
                        product.title = colorVariant.title;
                        product.price = colorVariant.price;
                        product.compare_at_price = colorVariant.compare_at_price;
                        product.formattedPrice = colorVariant.formattedPrice;
                        product.isPreorder = false;
                        product.selling_plan = sellingPlan && this.PREORDER_STATUS ? parseInt(sellingPlan) : null;
                      }
                    });
                    self.calculateTotalPrice();
                  }
                })

                break;
              default:
                break;
            }

            return;
          } else if (accessory.dataset.isToggle === 'true') {
            if (accessory.dataset.toggle === "true") {
              return;
            }
            accessory.classList.add("active");
            // Initialize to 'false' if undefined
            accessory.dataset.toggle = accessory.dataset.toggle || "false";

            // Toggle
            accessory.dataset.toggle = accessory.dataset.toggle === "true" ? "false" : "true";

            const toggle = accessory.dataset.toggle === "true";

            self.charpstAR.selectModelInScene(accessory.dataset.parentModulId);

            if (toggle) {
              // Find the sibling SKU with the longest common prefix (>=75%)
              const siblingProduct = self.temporaryCartProducts.find(
                (p) => p.sku !== accessory.dataset.sku && self.areSiblingSkus(p.sku, accessory.dataset.sku)
              );
              if (siblingProduct) {
                self.charpstAR.toggleMesh(siblingProduct.sku, false);
                const siblingEl = [...accessories].find((a) => a.dataset.sku === siblingProduct.sku);
                const cartSiblingEl = self.config.cartItems.querySelector('.cart-item[data-variant-id="' + siblingProduct.variant_id + '"][data-parent-modul-id="' + accessory.dataset.parentModulId + '"]');
                if (siblingEl && cartSiblingEl) {
                  siblingEl.dataset.toggle = "false";
                  siblingEl.classList.remove("active");
                  const temporaryCartProductEl = self.config.cartItems.querySelector('.cart-item[data-variant-id="' + siblingProduct.variant_id + '"][data-parent-modul-id="' + siblingProduct.parent_module_id + '"]');
                  if (!temporaryCartProductEl) return;
                  if (temporaryCartProductEl.dataset.parentModulId !== accessory.dataset.parentModulId) return;
                  self.removeProductFromCart(temporaryCartProductEl, siblingProduct.parent_module_id ?? null);
                  temporaryCartProductEl.remove();
                  self.calculateTotalPrice()
                  self.charpstAR.toggleMesh(accessory.dataset.sku, false)
                }
              }
            }
            if (self.charpstAR.toggleMesh(accessory.dataset.sku, toggle) === 1) {
              let variant = self.findAccessoryByItem(accessory, false);

              if (!variant) return;

              variant["product_id"] = variant.id;
              variant["selling_plan"] = null;
              variant["properties"] = {
                _configurator: "true",
              };
              variant["default_product_id"] = accessory.dataset.parentId;
              if (accessory.dataset.parentModulId) {
                variant["parent_module_id"] = accessory.dataset.parentModulId;
              }

              self.addToCartProduct(variant, true).then(() => {
                self.calculateTotalPrice();
              });
              return;
            }

            return;

          } else {
            self.buildAccessoryPopup(accessory);
          }*/

          self.buildAccessoryPopup(accessory);
        });
      });
    }
    const kitchenAccessories = charpstARConfigurator.config.accessorySections.kitchen_accessory.querySelectorAll(
      ".module-option:not(.back-button)",
    );
    if (kitchenAccessories.length !== 0) {
      kitchenAccessories.forEach((accessory) => {
        accessory.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          self.buildAccessoryPopup(accessory, true);
        });
      });
    }
  };

  closeSvg = () => {
    return `
            <svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="-0.75" x2="16.4487" y2="-0.75" transform="matrix(0.729537 0.683941 -0.729537 0.683941 0 1.05225)" stroke="white" stroke-width="1.5"/>
                <line y1="-0.75" x2="16.4487" y2="-0.75" transform="matrix(-0.729537 0.683941 -0.729537 -0.683941 12 0)" stroke="white" stroke-width="1.5"/>
            </svg>
        `;
  };

  buildColor = (variant) => {
    const { id, image, title, color, variant_id, selected, available } = variant;
    if(!color) {
      return '';
    }
    return `<div data-product-id="${id}" data-variant-id="${variant_id}" class="${selected ? "selected-color " : ""}color-option${available ? "" : " disabled"}">
                    <div class="color-circle"><img src="${image}" alt="${title} ${color}"></div>
                    <div class="color-name">${color}</div><div class="timesact-badge" data-product-id="${id}"></div>
                    ${this.PREORDER_STATUS ? `<div class="timesact-preorder-description" data-product-id="${id}"></div>` : ""}
                </div>
        `;
  };

  buildAccessory = (variant, isVariant, prodId = null, modulId = null) => {
    const { id, title, image, variant_id, product_handle, toggle } = variant;
    const backText = this.translations.back || "Tillbaka";
    if (isVariant) {
      let sku = variant.sku;
      return `
                <div class="module-option" data-parent-modul-id="${modulId}" data-product-handle="${product_handle}" data-parent-id="${prodId}" data-product-id="${id}" data-variant-id="${variant_id}" data-is-toggle="${toggle}" data-sku="${sku}" title="${title}">
                    <img src="${image}" title="${title}" alt="${title}">
                </div>
            `;
    } else {
      return `
                <div class="module-option back-button" data-product-id="null" data-variant-id="null" title="${backText}">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="800px" height="800px" viewBox="0 0 156.199 156.199" xml:space="preserve">
                        <g><path style="fill:#030303;" d="M102.496,45.204h-2.499v-0.012l-77.613-0.368l32.958-32.959l-8.277-8.28L0,50.65l47.882,47.889   l8.28-8.28l-33.719-33.73l71.642,0.346v0.04h8.417c23.151,0,41.993,18.838,41.993,41.997c0,23.151-18.842,41.992-41.993,41.992H0   v11.711h102.496c29.613,0,53.703-24.09,53.703-53.703C156.199,69.293,132.109,45.204,102.496,45.204z"/></g>
                    </svg>
                    <span>${backText}</span>
                </div>
            `;
    }
  };

  /**
   * Builds the accessory popup
   * @param item HTMLElement
   * @param isKitchenAccessory boolean
   */
  buildAccessoryPopup = (item, isKitchenAccessory = false) => {
    let self = this;
    const { parentId, variantId, sku, parentModulId, productHandle, productId, isToggle, toggle } = item.dataset;
    const variant = this.findAccessoryByItem(item, isKitchenAccessory);

    if (!variant || item.dataset.toggle === "true") {
      return;
    }

    const [variantPrimaryName, variantSecondaryName] = variant.title.split("-");
    const showSecondaryName = variantSecondaryName && variantSecondaryName !== "Default Title";

    this.config.accessoryPopup.innerHTML = `
            <div class="accessory-popup-close">
                ${this.closeSvg()}
            </div>
            <div class="accessory-popup-media">
                <img src="${variant.image}" title="${variantPrimaryName}" alt="${variantPrimaryName}" />
            </div>
            <div class="accessory-popup-title" data-parent-id="${parentId}" data-variant-id="${variantId}" data-sku="${sku}" data-is-kitchen-accessory="${isKitchenAccessory}" data-parent-modul-id="${parentModulId}" data-product-handle="${productHandle}" data-product-id="${productId}" data-is-toggle="${isToggle}" data-toggle="${toggle}" style="display: flex;flex-direction: row;justify-content: space-between;">
                <p style="display: flex; flex-direction: column;max-width: 80%; line-height: 1.25">
                  ${variant.name ? '<span>' + variant.name + '</span>': ''}
                  <span>${variantPrimaryName}</span>
                </p>
                <span class="product-preview__favour" data-product-handle="${variant.product_handle}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                        <path d="M35 14.9478C35 24.0605 20 33.75 20 33.75C20 33.75 5 24.0605 5 14.9478C5 5.83515 15.2137 2.72565 20 11.2809C24.7863 2.72565 35 5.83515 35 14.9478Z" stroke="#1C1C1C" stroke-width="1.5"/>
                    </svg>
                </span>
            </div>
            <div class="product-preview__rating">
                <div class="klaviyo-star-rating-widget" data-id="${variant.id}" data-product-title="${variant.title}" data-product-type="${variant.type}"></div>
            </div>
            <div class="acessory-popup-content">
                <span>${showSecondaryName ? variantSecondaryName : ""}</span>
                <div>
                    <div class="price product-preview__price">${variant.formattedPrice}</div>
                    <div class="add"><a ${variant.available ? "" : 'class="disabled"'} href="#">${this.translations.add || "Lägg"}</a></div>
                </div>
            </div>
        `;
    this.triggerAccessoryPopup(true);

    const closeBtn = this.config.accessoryPopup.querySelector(".accessory-popup-close");
    const addBtn = this.config.accessoryPopup.querySelector(".add");
    addBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (addBtn.querySelector("a").classList.contains("disabled")) return;

      self.config.accessorySections.accessory
        .querySelectorAll('.module-option[data-is-toggle="true"]:not(.back-button)')
        .forEach((el) => {
          if (el !== item) {
            el.dataset.toggle = "false";
            el.classList.remove("active");
            //self.charpstAR.toggleMesh(el.dataset.sku, false);

            const cartProductEl = self.config.cartItems.querySelector(
              '.cart-item[data-variant-id="' + el.dataset.variantId + '"][data-parent-modul-id="' + el.dataset.parentModulId + '"]',
            );
            if (!cartProductEl) return;
            if (cartProductEl.dataset.parentModulId !== el.dataset.parentModulId) return;
            self.removeProductFromCart(cartProductEl, el.dataset.parentModulId ?? null);
            cartProductEl.remove();
            self.calculateTotalPrice();
            self.updateShareButtonState();
          }
        });

      if (item.dataset.sku.includes("OL-2504SF-A-OD")) {
        if (item.dataset.toggle === "true") {
          return;
        }

        item.classList.add("active");


        // Initialize to 'false' if undefined
        item.dataset.toggle = item.dataset.toggle || "false";

        // Toggle
        item.dataset.toggle = item.dataset.toggle === "true" ? "false" : "true";

        const toggle = item.dataset.toggle === "true";
        let variant = null
        switch (self.charpstAR.toggleMesh("OL-2504SF-A-OD", toggle)) {
          case 1:
            variant = self.findAccessoryByItem(item, false);

            if (!variant) {
              self.triggerAccessoryPopup(false);
              return;
            }

            variant["product_id"] = variant.id;
            variant["selling_plan"] = null;
            variant["properties"] = {
              _configurator: "true",
            };
            variant["default_product_id"] = item.dataset.parentId;
            if (item.dataset.parentModulId) {
              variant["parent_module_id"] = item.dataset.parentModulId;
            }

            self.addToCartProduct(variant, true).then(() => {
              self.triggerAccessoryPopup(false);
              const childItem = self.config.cartItems.querySelector('.cart-item[data-parent-modul-id="' + item.dataset.parentModulId + '"]');

              const colorData = document.querySelector(".charpstar-configurator #charpstar-configurator-actions .color-section>.selected-color");
              const color = colorData.querySelector(".color-name .color").innerHTML.trim();

              if (childItem !== null && color !== self.translations.choose) {
                const accVar = self.products[item.dataset.parentId]["accessories"].find(
                  (i) => i.product_id == item.dataset.productId,
                );

                if (!accVar) {
                  self.triggerAccessoryPopup(false);
                  return;
                }

                const accVarVariants = accVar.variants;

                const colorVariant = accVarVariants.find((i) => i.color == color);
                if (!colorVariant) {
                  self.triggerAccessoryPopup(false);
                  return;
                }

                let properties = {};
                let sellingPlan = null;
                let shippingDate = null;
                properties["_configurator"] = "true";

                const childImage = childItem.querySelector(".cart-item-image img");
                childItem.dataset.productId = colorVariant.product_id;
                childItem.dataset.variantId = colorVariant.variant_id;
                childImage.src = colorVariant.featured_image;
                childImage.alt = colorVariant.name + " " + colorVariant.title;
                childImage.title = colorVariant.name + " " + colorVariant.title;
                childItem.querySelector(".cart-item-details .item-name").innerHTML = colorVariant.name;
                childItem.querySelector(".cart-item-details .item-specs").innerHTML = colorVariant.title;

                self.cartProducts.forEach((product) => {
                  if (product.parentModulId === item.dataset.parentModulId) {
                    product.id = colorVariant.variant_id;
                    product.price = colorVariant.price;
                    product.productId = colorVariant.product_id;
                    product.isPreorder = false;
                    product.properties = properties;
                    product.selling_plan = sellingPlan && this.PREORDER_STATUS ? parseInt(sellingPlan) : null;
                  }
                });

                self.temporaryCartProducts.forEach((product) => {
                  if (product.parent_module_id === item.dataset.parentModulId) {
                    product.variant_id = colorVariant.variant_id;
                    product.product_id = colorVariant.product_id;
                    product.sku = colorVariant.sku.replace(/-[^-]*$/, "");
                    product.isToggle = childItem.dataset.isToggle;
                    product.imageUrl = colorVariant.featured_image;
                    product.name = colorVariant.name;
                    product.title = colorVariant.title;
                    product.price = colorVariant.price;
                    product.compare_at_price = colorVariant.compare_at_price;
                    product.formattedPrice = colorVariant.formattedPrice;
                    product.isPreorder = false;
                    product.selling_plan = sellingPlan && this.PREORDER_STATUS ? parseInt(sellingPlan) : null;
                  }
                });
                /*if(item.dataset.sku !== 'XBQ2506') {
                self.charpstAR.toggleMesh('XBQ2506', 0)
                }*/
               self.triggerAccessoryPopup(false);
                self.calculateTotalPrice();
              }
            })

            break;
          default:
            variant = self.findAccessoryByItem(item, false);

            if (!variant) return;

            variant["product_id"] = variant.id;
            variant["selling_plan"] = null;
            variant["properties"] = {
              _configurator: "true",
            };
            variant["default_product_id"] = item.dataset.parentId;
            if (item.dataset.parentModulId) {
              variant["parent_module_id"] = item.dataset.parentModulId;
            }

            self.addToCartProduct(variant, true).then(() => {
              const childItem = self.config.cartItems.querySelector('.cart-item[data-parent-modul-id="' + item.dataset.parentModulId + '"]');

              const colorData = document.querySelector(".charpstar-configurator #charpstar-configurator-actions .color-section>.selected-color");
              const color = colorData.querySelector(".color-name .color").innerHTML.trim();

              if (childItem !== null && color !== self.translations.choose) {
                const accVar = self.products[item.dataset.parentId]["accessories"].find(
                  (i) => i.product_id == item.dataset.productId,
                );

                if (!accVar) {
                  return;
                }

                const accVarVariants = accVar.variants;

                const colorVariant = accVarVariants.find((i) => i.color == color);
                if (!colorVariant) {
                  return;
                }

                let properties = {};
                let sellingPlan = null;
                let shippingDate = null;
                properties["_configurator"] = "true";

                const childImage = childItem.querySelector(".cart-item-image img");
                childItem.dataset.productId = colorVariant.product_id;
                childItem.dataset.variantId = colorVariant.variant_id;
                childImage.src = colorVariant.featured_image;
                childImage.alt = colorVariant.name + " " + colorVariant.title;
                childImage.title = colorVariant.name + " " + colorVariant.title;
                childItem.querySelector(".cart-item-details .item-name").innerHTML = colorVariant.name;
                childItem.querySelector(".cart-item-details .item-specs").innerHTML = colorVariant.title;

                self.cartProducts.forEach((product) => {
                  if (product.parentModulId === item.dataset.parentModulId) {
                    product.id = colorVariant.variant_id;
                    product.price = colorVariant.price;
                    product.productId = colorVariant.product_id;
                    product.isPreorder = false;
                    product.properties = properties;
                    product.selling_plan = sellingPlan && this.PREORDER_STATUS ? parseInt(sellingPlan) : null;
                  }
                });

                self.temporaryCartProducts.forEach((product) => {
                  if (product.parent_module_id === item.dataset.parentModulId) {
                    product.variant_id = colorVariant.variant_id;
                    product.product_id = colorVariant.product_id;
                    product.sku = colorVariant.sku.replace(/-[^-]*$/, "");
                    product.isToggle = childItem.dataset.isToggle;
                    product.imageUrl = colorVariant.featured_image;
                    product.name = colorVariant.name;
                    product.title = colorVariant.title;
                    product.price = colorVariant.price;
                    product.compare_at_price = colorVariant.compare_at_price;
                    product.formattedPrice = colorVariant.formattedPrice;
                    product.isPreorder = false;
                    product.selling_plan = sellingPlan && this.PREORDER_STATUS ? parseInt(sellingPlan) : null;
                  }
                });
                self.triggerAccessoryPopup(false);
                self.calculateTotalPrice();
              }
            })
            break;
        }

        return;
      } else if (item.dataset.isToggle === 'true') {
        if (item.dataset.toggle === "true") {
          return;
        }
        item.classList.add("active");
        // Initialize to 'false' if undefined
        item.dataset.toggle = item.dataset.toggle || "false";

        // Toggle
        item.dataset.toggle = item.dataset.toggle === "true" ? "false" : "true";

        const toggle = item.dataset.toggle === "true";

        self.charpstAR.selectModelInScene(item.dataset.parentModulId);

        if (toggle) {
          // Find the sibling SKU with the longest common prefix (>=75%)
          const siblingProduct = self.temporaryCartProducts.find(
            (p) => p.sku !== item.dataset.sku && self.areSiblingSkus(p.sku, item.dataset.sku)
          );
          if (siblingProduct) {
            //self.charpstAR.toggleMesh(siblingProduct.sku, false);
            const siblingEl = [...self.config.accessorySections.accessory.querySelectorAll('.module-option:not(.back-button)')].find((a) => a.dataset.sku === siblingProduct.sku);
            const cartSiblingEl = self.config.cartItems.querySelector('.cart-item[data-variant-id="' + siblingProduct.variant_id + '"][data-parent-modul-id="' + item.dataset.parentModulId + '"]');
            if (siblingEl && cartSiblingEl) {
              siblingEl.dataset.toggle = "false";
              siblingEl.classList.remove("active");
              const temporaryCartProductEl = self.config.cartItems.querySelector('.cart-item[data-variant-id="' + siblingProduct.variant_id + '"][data-parent-modul-id="' + siblingProduct.parent_module_id + '"]');
              if (!temporaryCartProductEl) return;
              if (temporaryCartProductEl.dataset.parentModulId !== item.dataset.parentModulId) return;
              self.removeProductFromCart(temporaryCartProductEl, siblingProduct.parent_module_id ?? null);
              temporaryCartProductEl.remove();
              self.calculateTotalPrice()
              //self.charpstAR.toggleMesh(item.dataset.sku, false)
            }
          }
        }
        if (self.charpstAR.toggleMesh(item.dataset.sku, toggle) === 1) {
          let variant = self.findAccessoryByItem(item, false);

          if (!variant) return;


          variant["product_id"] = variant.id;
          variant["selling_plan"] = null;
          variant["properties"] = {
            _configurator: "true",
          };
          variant["default_product_id"] = item.dataset.parentId;
          if (item.dataset.parentModulId) {
            variant["parent_module_id"] = item.dataset.parentModulId;
          }

          self.addToCartProduct(variant, true).then(() => {
            /*if(item.dataset.sku !== 'XBQ2506') {
              self.charpstAR.toggleMesh('XBQ2506', 0)
            }*/
            self.calculateTotalPrice();
            self.triggerAccessoryPopup(false);
          });
          return;
        }

        return;

      } else {
        variant["product_id"] = parentId;
        variant["selling_plan"] = null;
        variant["properties"] = {
          _configurator: "true",
        };
        self.addToCartProduct(variant, true).then(() => {
          self.calculateTotalPrice();
          self.triggerAccessoryPopup(false);
        });
        return;
      }
    });

    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      self.triggerAccessoryPopup(false);
    });
  };

  /**
   * Find the accessory by item
   *
   * @param item
   * @param isKitchenAccessory
   * @returns {*}
   */
  findAccessoryByItem = (item, isKitchenAccessory = false) => {
    const { parentId, variantId } = item.dataset;
    const accessoryType = isKitchenAccessory ? "kitchen_accessories" : "accessories";

    return this.products[parentId]?.[accessoryType]?.find((accessory) => accessory.variant_id === variantId);
  };

  triggerAccessoryPopup = (show) => {
    if (!this.config.accessoryOverlay || !this.config.accessoryPopup) return;

    const FADE_DURATION = 250;
    const elements = [this.config.accessoryOverlay, this.config.accessoryPopup];

    elements.forEach((element) => {
      element.classList.toggle("active", show);
      this.fade(element, show ? "in" : "out", FADE_DURATION);
    });

    if (!show) {
      setTimeout(() => {
        this.config.accessoryPopup.innerHTML = "";
      }, FADE_DURATION);
    }
  };

  fade = (element, type, duration = 500) => {
    if (!element) return;

    const isIn = type === "in";

    Object.assign(element.style, {
      transition: `opacity ${duration}ms ease`,
      opacity: isIn ? "1" : "0",
    });

    element.addEventListener(
      "transitionend",
      () => {
        element.style.display = isIn ? "" : "none";
      },
      { once: true },
    );
  };

  formatMoney = (cents, format) => {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || "${{amount}}";

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return "0";
      }

      // Convert cents to dollars and round
      number = number / 100.0;

      if (precision === 0) {
        number = Math.round(number).toFixed(0);
      } else {
        number = number.toFixed(precision);
      }

      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0); // This will now properly round
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  loadModel = (sku) => {
    this.charpstAR.addModel(sku);
  };

  loadPreorder = async (reloadFull = false) => {
    let self = this;
    if (reloadFull) {
    }

    // Initialize jQuery if needed
    if (typeof jQuery191 === "undefined") {
      if (typeof jQuery === "undefined" || parseFloat(jQuery.fn.jquery) < 100.0) {
        await new Promise((resolve) => {
          loadScript("https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js", async () => {
            jQuery191 = jQuery.noConflict(true);
            await timesactScriptNew(jQuery191);
            resolve();
          });
        });
      } else {
        await timesactScriptNew(jQuery);
      }
    } else {
      await timesactScriptNew(jQuery191);
    }

    self.preorderData.products = ta.products;

    // Find preorder settings
    self.preorderData.settings = ta.settings ? Object.entries(ta.settings).find(([key, value]) => value.type === "PO") : null;

    if (self.preorderData.settings) {
      const [key, value] = self.preorderData.settings;
      self.preorderData.settings = { id: key, ...value };
    }

    this.findPreorderData();
  };

  findPreorderData = () => {
    if (!this.config.colorContainer.querySelectorAll(".color-option").length) {
      return ''
    }

    this.config.colorContainer.querySelectorAll(".color-option").forEach((color) => {
      if (this.preorderData.products[color.dataset.productId]) {
        const preorderProduct = this.preorderData.products[color.dataset.productId];
        if (preorderProduct?.isPreorder && preorderProduct?.variants?.[color.dataset.variantId]?.config?.shippingDate?.date) {
          if (color.querySelector(".timesact-preorder-description") !== null) {
            color.querySelector(".timesact-preorder-description").innerHTML =
              this.preorderData.settings.message.value.replace(
                this.PREORDER_SHIPPING_PLACEHOLDER,
                this.timestampToDate(preorderProduct.variants[parseInt(color.dataset.variantId)].config.shippingDate.date),
              );
          }
        }
      }
    });
  };

  timestampToDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return formatter.format(date);
  };

  calculateTotalPrice = () => {
    let price = 0;

    if (this.cartProducts.length === 0) {
      this.config.totalSection.querySelector("div:last-of-type").innerHTML = this.formatMoney(
        "000",
        this.shopFormat.moneyFormat,
      );
      return;
    }

    // Track which bundles we've already added to the total
    const talliedBundles = new Set();

    this.temporaryCartProducts.forEach((product) => {
      // If the product belongs to a bundle, add the bundle_price only ONCE per group
      if (product.bundle_id) {
        if (!talliedBundles.has(product.bundle_id)) {
          talliedBundles.add(product.bundle_id);
          const bundlePrice = parseInt(product.bundle_price);
          price += (bundlePrice / 100);
        }
      } else {
        // Individual product logic
        const convertedPrice = parseInt(product.price);
        price += (convertedPrice / 100).toFixed(0) * product.count;
      }
    });

    this.config.totalSection.querySelector("div:last-of-type").innerHTML = this.formatMoney(
      price.toString() + "00",
      this.shopFormat.moneyFormat,
    );
  };

  updateShareButtonState = () => {
    if (!this.config.shareButton) {
      return;
    }

    const hasCartProducts = this.cartProducts && this.cartProducts.length > 0;
    const hasTemporaryCartProducts = this.temporaryCartProducts && this.temporaryCartProducts.length > 0;

    if (hasCartProducts && hasTemporaryCartProducts) {
      this.config.shareButton.classList.remove('disabled');
    } else {
      this.config.shareButton.classList.add('disabled');
    }
  };

  applySelectedColor = (selectedColor, colorName, image, alt) => {
    const colorLower = this.getColor(colorName);

    // Single DOM query and combined updates
    const colorElement = selectedColor.querySelector(".color-name .color");
    const circleElement = selectedColor.querySelector(".color-circle");

    colorElement.textContent = colorName;
    circleElement.innerHTML = `<img src="${image}" alt="${alt}"/>`;

    this.charpstAR.setSelectedColor(this.colors[colorLower]);

    selectedColor.classList.remove("active");
    this.config.colorContainer.classList.remove("active");

    if (this.lastAddedModul !== null) {
      this.lastAddedModul["color"] = colorLower;
    }
  };

  getColor = (color) => {
    return color.replace(/\s+/g, "").toLowerCase();
  };

  removeActiveClass = (item, isArray = false) => {
    if (isArray) {
      item.forEach((el) => el.classList.remove("active"));
    } else {
      item.classList.remove("active");
    }
  };

  removeColorOptions = () => {
    this.configurator.querySelector(".selected-color").innerHTML = this.config.defaultSelectedColorHtml;
    this.config.colorContainer.innerHTML = "";
  };

  resetToModules = () => {
    this.config.accessorySections.accessory.innerHTML = "";
    this.config.accessorySections.kitchen_accessory.innerHTML = "";
    this.config.accessorySections.accessory.classList.remove("active");
    this.config.accessorySections.kitchen_accessory.classList.remove("active");
    this.config.colorSection.classList.remove("active");
    this.removeColorOptions();
    this.config.moduleSection.classList.remove("hidden");
    this.config.sectionTitles.products.classList.remove("hidden");
    this.config.sectionTitles.accessories.classList.add("hidden");
    this.config.sectionTitles.kitchen_accessories.classList.add("hidden");
  };

  generateCartHtml = (item, preorderText = null) => {
    return `
                  <div class="cart-item" data-default-id="${item.default_id}" data-parent-id="${item.default_product_id}" data-parent-modul-id="${item.parent_module_id ?? null}" data-variant-id="${item.variant_id}" data-product-id="${item.product_id}" data-sku="${item.sku.replace(/-[^-]*$/, "")}" data-modul-id="${item.modulId}" data-toggle="${item.isToggle}">
                      <div class="cart-item-image">
                          ${item.imageUrl ? `<img src="${item.imageUrl}" alt="${item.name}">` : ""}
                          <div class="item-count">${item.count}</div>
                      </div>
                      <div class="cart-item-details">
                          <div class="item-name">${item.name}</div>
                          <div class="item-specs">${item.title}</div>
                          ${this.PREORDER_STATUS ? `<div class="item-preorder">${preorderText ? preorderText : ``}</div>` : ""}
                          <div class="item-actions">
                              <a href="#" class="item-change">
                                  <span>${this.translations.change}</span>
                              </a>
                              <a href="#" class="item-delete">
                                  <span>${this.translations.itemDelete}</span>
                              </a>
                          </div>
                      </div>

                      <div class="item-price">${item.formattedPrice}
                      ${item.compare_at_price > 0 && item.compare_at_price !== item.price ? `<span class="item-old-price">${formatMoney(item.compare_at_price, shopFormat.moneyFormat)}</span>` : ""}
                      </div>
                  </div>
              `;
  };

  addToCartProduct = (variant, isToggle = false, color = false) => {
    let self = this;
    const cartProduct = this.config.cartItems.querySelector(
      '.cart-items .cart-item[data-modul-id="' + variant.modulId + '"]',
    );
    let quantity = 1;
    if (cartProduct !== null) {
      quantity = parseInt(cartProduct.querySelector(".item-count").innerHTML) + 1;
    }

    const cartItem = {
      count: 1,
      imageUrl: variant.featured_image || "",
      name: variant.name || variant.title,
      compare_at_price: variant.compare_at_price || "",
      price: variant.formattedPrice || "8 595,00 kr",
      title: variant.title || "",
    };


    return this.getPreorderData(variant).then((preorderData) => {
      let isPreorderProduct = false;
      let properties = {};
      let sellingPlan = null;
      let shippingDate = null;

      properties["_configurator"] = "true";

      if (preorderData !== null && preorderData.product.variants[variant.variant_id]) {
        const preorderVariant = preorderData.product.variants[variant.variant_id];
        if (preorderVariant.isPOEnabled) {
          isPreorderProduct = true;
          shippingDate = preorderVariant.config.shippingDate.date;
          if (this.PREORDER_STATUS) {
            sellingPlan = preorderVariant.config.sellingPlan;
            properties[this.preorderData.settings.cart.labelText.key] =
              this.preorderData.settings.cart.labelText.value.replace(
                this.PREORDER_SHIPPING_PLACEHOLDER,
                this.timestampToDate(shippingDate),
              );
          }
        }
      }

      const temporaryCartItem = {
        parent_module_id: variant.parent_module_id ?? null,
        variant_id: variant.variant_id ?? null,
        product_id: variant.product_id,
        default_id: variant.product_id,
        default_product_id: variant.default_product_id || variant.product_id,
        sku: variant.sku.replace(/-[^-]*$/, ""),
        modulId: variant.modulId ?? "",
        isToggle: isToggle,
        imageUrl: cartItem.imageUrl,
        name: cartItem.name,
        title: cartItem.title,
        count: cartItem.count,
        price: variant.price,
        formattedPrice: variant.formattedPrice,
        compare_at_price: cartItem.compare_at_price,
        isPreorder: isPreorderProduct ? isPreorderProduct : false,
        selling_plan: sellingPlan,
        properties: properties,
      };

      this.temporaryCartProducts = [...this.temporaryCartProducts, temporaryCartItem];

      this.cartProducts.push({
        id: variant.variant_id,
        quantity: cartItem.count,
        price: variant.price,
        defaultId: variant.product_id,
        defaultProductId: variant.default_product_id || variant.product_id,
        productId: variant.product_id,
        modulId: variant.modulId,
        parentModulId: variant.parent_module_id ?? null,
        isPreorder: isPreorderProduct ? isPreorderProduct : false,
        properties: properties,
        selling_plan: sellingPlan,
      });

      this.config.cartItems.insertAdjacentHTML("beforeend", this.generateCartHtml(temporaryCartItem, isPreorderProduct ? properties[this.preorderData.settings.cart.labelText.key] : null));

      this.applyCartItemEventListeners();

      this.calculateTotalPrice();
      this.updateShareButtonState();
    });
  };

  async getPreorderData(variant) {
    try {
      const response = await fetch('https://dangarden.se/apps/timesact/config?productId=' + variant.id);

      // If the server returns a 404, response.ok is false.
      // We return null immediately so it doesn't try to parse broken JSON.
      if (!response.ok) {
        return null;
      }

      const data = await response.json();
      return data;

    } catch (error) {
      // This silently catches true network failures or JSON parsing issues
      // returning null so the rest of your code knows there's no pre-order.
      return null;
    }
  }

  updateProductInCart = (variant, moduleId, isPreorder = false, color = null) => {
    const cartProduct = this.config.cartItems.querySelector('.cart-item[data-modul-id="' + moduleId + '"]');

    if (cartProduct === null) {
      return;
    }

    const image = cartProduct.querySelector(".cart-item-image img");
    cartProduct.dataset.productId = variant.id;
    cartProduct.dataset.variantId = variant.variant_id;
    image.src = variant.featured_image;
    image.alt = variant.name + " " + variant.title;
    image.title = variant.name + " " + variant.title;
    cartProduct.querySelector(".cart-item-details .item-name").innerHTML = variant.name;
    cartProduct.querySelector(".cart-item-details .item-specs").innerHTML = variant.title;

    cartProduct.querySelector(".item-price").innerHTML = variant.formattedPrice;

    if (variant.compare_at_price > 0 && variant.price !== variant.compare_at_price) {
      cartProduct.querySelector(".item-price").innerHTML =
        `${variant.formattedPrice}<span class="item-old-price">${this.formatMoney(variant.compare_at_price, this.shopFormat.moneyFormat)}</span>`;
    } else {
      cartProduct.querySelector(".item-price").innerHTML = variant.formattedPrice;
    }

    let isPreorderProduct = false;
    let properties = {};
    let sellingPlan = null;
    let shippingDate = null;

    properties["_configurator"] = "true";

    return this.getPreorderData(variant).then((preorderData) => {
      let isAsyncPreorderData = false;

      if (preorderData !== null && preorderData.product.variants[variant.variant_id] && preorderData.product.variants[variant.variant_id].isPOEnabled) {
        isAsyncPreorderData = true;
        const preorderVariant = preorderData.product.variants[variant.variant_id];
        if (preorderVariant.isPOEnabled) {
          isPreorderProduct = true;
          shippingDate = preorderVariant.config.shippingDate.date;
          if (this.PREORDER_STATUS) {
            sellingPlan = preorderVariant.config.sellingPlan;
            properties[this.preorderData.settings.cart.labelText.key] =
              this.preorderData.settings.cart.labelText.value.replace(
                this.PREORDER_SHIPPING_PLACEHOLDER,
                this.timestampToDate(shippingDate),
              );
          }
        }
      }

      if (!isAsyncPreorderData && this.preorderData.products[variant.id]) {
        const preorderProduct = this.preorderData.products[variant.id];
        if (preorderProduct.isPreorder) {
          isPreorderProduct = true;
        }

        if (isPreorderProduct) {
          const preorderVariant = preorderProduct.variants[variant.variant_id];
          if (typeof preorderVariant !== "undefined") {
            isPreorderProduct = true;
            shippingDate = preorderVariant.config.shippingDate.date;
            if (this.PREORDER_STATUS) {
              sellingPlan = preorderVariant.config.sellingPlan;
              properties[this.preorderData.settings.cart.labelText.key] =
                this.preorderData.settings.cart.labelText.value.replace(
                  this.PREORDER_SHIPPING_PLACEHOLDER,
                  this.timestampToDate(shippingDate),
                );
            }
          } else {
            isPreorderProduct = false;
          }
        }
      }

      if (isPreorderProduct && this.PREORDER_STATUS) {
        if (cartProduct.querySelector(".item-preorder") !== null) {
          cartProduct.querySelector(".item-preorder").innerHTML =
            `${this.preorderData.settings.message.value.replace(this.PREORDER_SHIPPING_PLACEHOLDER, this.timestampToDate(shippingDate))}`;
        }
      } else {
        if (cartProduct.querySelector(".item-preorder") !== null) {
          cartProduct.querySelector(".item-preorder").innerHTML = "";
        }
      }

      this.cartProducts.forEach((product) => {
        if (product.modulId === moduleId) {
          product.id = variant.variant_id;
          product.price = variant.price;
          product.productId = variant.product_id;
          product.isPreorder = isPreorderProduct && this.PREORDER_STATUS;
          product.properties = properties;
          product.selling_plan = sellingPlan && this.PREORDER_STATUS ? parseInt(sellingPlan) : null;
        }
      });

      this.temporaryCartProducts.forEach((product) => {
        if (product.modulId === moduleId) {
          if (cartProduct.dataset.parentModuleId) {
            product.parent_module_id = cartProduct.dataset.parentModuleId;
          }
          product.variant_id = variant.variant_id;
          product.product_id = variant.product_id;
          product.sku = variant.sku.replace(/-[^-]*$/, "");
          product.isToggle = cartProduct.dataset.isToggle;
          product.imageUrl = variant.featured_image;
          product.name = variant.name;
          product.title = variant.title;
          product.price = variant.price;
          product.compare_at_price = variant.compare_at_price;
          product.formattedPrice = variant.formattedPrice;
          product.isPreorder = isPreorderProduct && this.PREORDER_STATUS;
          product.properties = properties;
          product.selling_plan = sellingPlan && this.PREORDER_STATUS ? parseInt(sellingPlan) : null;
        }
      });

      this.temporaryCartProducts = [...this.temporaryCartProducts];

      this.calculateTotalPrice();

      if (!moduleId) {
        return;
      }

      const childItem = this.config.cartItems.querySelector('.cart-item[data-parent-modul-id="' + moduleId + '"]');

      if (childItem !== null && color) {
        const accVar = this.products[childItem.dataset.parentId]["accessories"].find(
          (item) => item.id == childItem.dataset.defaultId,
        );

        if (!accVar) {
          return;
        }

        const accVarVariants = accVar.variants;

        if (!accVarVariants) {
          return;
        }

        const colorVariant = accVarVariants.find((i) => i.color == color);
        if (!colorVariant) {
          return;
        }

        const childImage = childItem.querySelector(".cart-item-image img");
        childItem.dataset.productId = colorVariant.product_id;
        childItem.dataset.variantId = colorVariant.variant_id;
        childImage.src = colorVariant.featured_image;
        childImage.alt = colorVariant.name + " " + colorVariant.title;
        childImage.title = colorVariant.name + " " + colorVariant.title;
        childItem.querySelector(".cart-item-details .item-name").innerHTML = colorVariant.name;
        childItem.querySelector(".cart-item-details .item-specs").innerHTML = colorVariant.title;

        this.cartProducts.forEach((product) => {
          if (product.parentModulId === moduleId) {
            product.id = colorVariant.variant_id;
            product.price = colorVariant.price;
            product.productId = colorVariant.product_id;
            product.isPreorder = false;
            product.properties = properties;
            product.selling_plan = sellingPlan && this.PREORDER_STATUS ? parseInt(sellingPlan) : null;
          }
        });

        this.temporaryCartProducts.forEach((product) => {
          if (product.parent_module_id === moduleId) {
            product.variant_id = colorVariant.variant_id;
            product.product_id = colorVariant.product_id;
            product.sku = colorVariant.sku.replace(/-[^-]*$/, "");
            product.isToggle = cartProduct.dataset.isToggle;
            product.imageUrl = colorVariant.featured_image;
            product.name = colorVariant.name;
            product.title = colorVariant.title;
            product.price = colorVariant.price;
            product.compare_at_price = colorVariant.compare_at_price;
            product.formattedPrice = colorVariant.formattedPrice;
            product.isPreorder = false;
            product.properties = properties;
            product.selling_plan = sellingPlan && this.PREORDER_STATUS ? parseInt(sellingPlan) : null;
          }
        });

        this.calculateTotalPrice();
        this.updateShareButtonState();
      }
    })
  };

  clearCartMessage = () => {
    const cartResponse = this.configurator.querySelector(".cart-response");
    cartResponse.innerHTML = "";
    cartResponse.classList.remove("error");
    cartResponse.classList.remove("success");
  }

  addToCart = () => {
    let self = this;

    const cartResponse = self.configurator.querySelector(".cart-response");
    cartResponse.innerHTML = "";
    cartResponse.classList.remove("error");
    cartResponse.classList.remove("success");
    this.saveToSession();
    const tmpCartProducts = self.cartProducts;
    const itemsToSubmit = [];
    const processedBundles = new Set();


    self.cartProducts.forEach((product) => {
      // If the product belongs to a bundle, replace the individual items with a single bundle item
      if (product.bundle_id && product.bundle_product_id) {
        if (!processedBundles.has(product.bundle_id)) {
          processedBundles.add(product.bundle_id);

          let bundleItem = {
            id: parseInt(product.bundle_product_id),
            quantity: 1, // Add one instance of the bundle product
            properties: {
              _configurator: "true",
              _bundle_id: product.bundle_id
            }
          };

          if (product.bundle_product_properties && typeof product.bundle_product_properties === 'object' && Object.keys(product.bundle_product_properties).length > 0) {
            bundleItem.properties = {
              ...bundleItem.properties,
              ...product.bundle_product_properties
            };
          }

          /*if (product.bundle_selling_plan !== undefined && product.bundle_selling_plan !== null && product.bundle_selling_plan !== "") {
            bundleItem.selling_plan = product.bundle_selling_plan;
          }*/

          itemsToSubmit.push(bundleItem);
        }
      } else {
        // Handle individual unbundled products
        const itemToSubmit = { ...product };
        itemToSubmit.id = parseInt(product.id);

        if (!itemToSubmit.selling_plan || !self.PREORDER_STATUS) {
          delete itemToSubmit.selling_plan;
        }

        if (!itemToSubmit.hasOwnProperty("properties")) {
          itemToSubmit.properties = {
            _configurator: "true",
          };
        }

        itemsToSubmit.push(itemToSubmit);
      }
    });

    fetch(Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: JSON.stringify({
        items: itemsToSubmit,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        const data = await response.json();

        if (!response.ok) {
          cartResponse.innerHTML = data.description || data.message || "Failed to add to cart";
          cartResponse.classList.add("error");
          console.error("Error details:", data);
          self.cartProducts = tmpCartProducts;
          self.clearSession();
          //await self.removeConfiguratorProducts();
          throw new Error(data.description || data.message || "Failed to add to cart");
        }

        this.calculateTotalPrice();

        if (self.REFRESH_CART && typeof window.DangardenTheme.refreshCart === "function") {
          cartResponse.innerHTML = "";
          self.refreshCart();
        } else {
          cartResponse.innerHTML = self.translations.checkoutSuccess;
          cartResponse.classList.add("success");
          window.setTimeout(() => {
            self.redirectToCheckout();
          }, 1000);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  removeProductFromCart = (item, parentModulId) => {
    let self = this;
    const modulId = item.dataset.modulId;
    const variantId = item.dataset.variantId;
    let toggleSku = null;

    // Check if this item is inside a bundle wrapper. If so, dissolve the bundle.
    const bundleWrapper = item.closest('.cart-item-bundle');
    if (bundleWrapper) {
      const bundleId = bundleWrapper.dataset.bundleId;

      // 1. Break the DOM wrapper (move all .cart-item children out to before the wrapper, then delete wrapper and header)
      while (bundleWrapper.firstChild) {
        if (bundleWrapper.firstChild.classList && bundleWrapper.firstChild.classList.contains('cart-item')) {
          bundleWrapper.parentNode.insertBefore(bundleWrapper.firstChild, bundleWrapper);
        } else {
          // It's the header or whitespace; just remove it
          bundleWrapper.firstChild.remove();
        }
      }
      bundleWrapper.remove();

      // 2. Clear the bundle info from any items sharing this bundleId in data arrays
      self.cartProducts.forEach(p => {
        if (p.bundle_id === bundleId) {
          delete p.bundle_id;
          delete p.bundle_product_id;
        }
      });
      self.#temporaryCartProducts.forEach(p => {
        if (p.bundle_id === bundleId) {
          delete p.bundle_id;
          delete p.bundle_product_id;
        }
      });
      // (Trigger the observer manually if needed, though filtering items below might not trigger it directly if manipulated. The removal step below will re-render or trigger updates natively.)
    }

    if (parentModulId && parentModulId != "null") {
      self.charpstAR.selectModelInScene(parentModulId);
      self.charpstAR.toggleMesh(item.dataset.sku, false);
      self.cartProducts = self.cartProducts.filter((item) => item.parentModulId !== parentModulId);
      self.temporaryCartProducts = self.temporaryCartProducts.filter((item) => item.parent_module_id !== parentModulId);
    } else {
      if (modulId && modulId != "null") {
        const childItem = this.config.cartItems.querySelector('.cart-item[data-parent-modul-id="' + modulId + '"]');

        if (childItem) {
          childItem.remove();

          self.cartProducts = self.cartProducts.filter((item) => item.parentModulId !== modulId);
          self.temporaryCartProducts = self.temporaryCartProducts.filter((item) => item.parent_module_id !== modulId);
        }
      }

      if (modulId && modulId != "null") {
        self.charpstAR.deleteModelInScene(modulId);
        self.cartProducts = self.cartProducts.filter((item) => item.modulId !== modulId);
        self.temporaryCartProducts = self.temporaryCartProducts.filter((item) => item.modulId !== modulId);
      } else {
        self.cartProducts = self.cartProducts.filter((item) => item.id !== variantId);
        self.temporaryCartProducts = self.temporaryCartProducts.filter((item) => item.variant_id !== variantId);
      }
    }

    self.refreshCartAfterRemove(variantId);
    self.updateShareButtonState();
    return;
  };

  applyCartItemEventListeners = () => {
    const self = this;
    this.config.cartItems.querySelectorAll(".cart-item").forEach((item) => {
      item.querySelector(".item-change").addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const productId = item.dataset.productId;
        const modulId = item.dataset.modulId;
        if (modulId === "undefined") {
          return;
        }

        //Select module in scene
        const jsonData = self.charpstAR.getJsonData();
        const parentModuleExists = jsonData.modules.some((module) => module.key === item.dataset.parentModulId);

        if (parentModuleExists) {
          self.charpstAR.selectModelInScene(item.dataset.parentModulId);
        } else {
          self.charpstAR.selectModelInScene(modulId);
        }

        self.config.moduleOptions.forEach((option) => {
          option.classList.remove("active");
          if (option.dataset.productId === productId) {
            option.dispatchEvent(new CustomEvent("click", { detail: { key: modulId, update: true } }));
          }
        });
      });

      item.querySelector(".item-delete").addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        self.removeProductFromCart(item, item.dataset.parentModulId);

        item.remove();
      });
    });
  };

  refreshCartAfterRemove = (variantId) => {
    let self = this;

    self.config.moduleSection.classList.remove("hidden");
    self.config.sectionTitles.products.classList.remove("hidden");
    self.config.sectionTitles.accessories.classList.add("hidden");
    self.config.sectionTitles.kitchen_accessories.classList.add("hidden");
    self.config.colorSection.classList.remove("active");
    self.config.accessorySections.accessory.classList.remove("active");
    self.config.accessorySections.kitchen_accessory.classList.remove("active");

    self.removeActiveClass(self.config.moduleOptions, true);

    self.calculateTotalPrice();
  };

  redirectToCheckout = () => {
    window.location.href = Shopify.routes.root + "checkout";
  };

  resetToDefault = () => {
    this.config.moduleSection.classList.remove("hidden");
    this.config.colorSection.classList.remove("active");
    this.config.sectionTitles.products.classList.remove("hidden");
    this.config.sectionTitles.accessories.classList.add("hidden");
    this.config.sectionTitles.kitchen_accessories.classList.add("hidden");
    this.config.cartItems.innerHTML = "";
    this.cartProducts = [];
    //this.charpstAR.clearModel();

    if (document.querySelector("input[type=checkbox]#change-all-colors").checked) {
      document.querySelector("#change-all-colors").click();
    }

    this.calculateTotalPrice();
    this.updateShareButtonState();

    document.querySelector(".cart-popup").classList.add("active");
  };

  refreshCart = () => {
    const self = this;

    window.DangardenTheme.refreshCart(true);

    //this.charpstAR.clearModel();
    this.resetToModules();
    /*this.cartProducts = [];
    this.config.cartItems.innerHTML = "";*/
    this.calculateTotalPrice();
  };

  recreateTemporaryCart = (data) => {
    let self = this;

    // 1. Group items by bundle_id so we can wrap them correctly
    const standaloneItems = [];
    const bundledGroups = {}; // { [bundle_id]: [item1, item2, ...] }

    data.forEach((product) => {
      if (product.bundle_id) {
        if (!bundledGroups[product.bundle_id]) {
          bundledGroups[product.bundle_id] = [];
        }
        bundledGroups[product.bundle_id].push(product);
      } else {
        standaloneItems.push(product);
      }
    });

    // 2. Render bundled groups
    Object.keys(bundledGroups).forEach(bundleId => {
      const items = bundledGroups[bundleId];
      // Lookup the parent bundle using the bundle_product_id of the first item
      const bpid = items[0].bundle_product_id;
      const masterBundle = fullBundles && fullBundles.find(b => String(b.variant_id) === String(bpid));

      const wrapper = document.createElement('div');
      wrapper.className = 'cart-item-bundle';
      wrapper.dataset.bundleId = bundleId;

      if (masterBundle) {
        // Create an info header for the bundle
        const bundleHeader = document.createElement('div');
        bundleHeader.className = 'cart-item-bundle-header';

        const priceHTML = masterBundle.compare_at_price > 0 && masterBundle.price !== masterBundle.compare_at_price
          ? `<span class="item-old-price">${self.formatMoney(masterBundle.compare_at_price, self.shopFormat.moneyFormat)}</span>`
          : '';

        bundleHeader.innerHTML = `
          <div class="bundle-title"><strong>${masterBundle.title}</strong></div>
          <div class="bundle-price"><strong>${masterBundle.formattedPrice}</strong> ${priceHTML}</div>
        `;
        wrapper.appendChild(bundleHeader);
      } else {
        // Fallback if fullBundles isn't loaded or match failed (should rarely happen)
        const fallbackHeader = document.createElement('div');
        fallbackHeader.className = 'cart-item-bundle-header';
        fallbackHeader.innerHTML = `
          <div class="bundle-title"><strong>Bundle</strong></div>
          <div class="bundle-price"></div>
       `;
        wrapper.appendChild(fallbackHeader);
      }

      // Generate HTML for each item and append directly to wrapper
      items.forEach(product => {
        const preorderText = (this.PREORDER_STATUS && product.properties[this.preorderData.settings.cart.labelText.key])
          ? product.properties[this.preorderData.settings.cart.labelText.key] : null;

        // Use a temporary container to convert HTML string to actual DOM node
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = self.generateCartHtml(product, preorderText);
        // The first child should be the .cart-item
        if (tempDiv.firstElementChild) {
          wrapper.appendChild(tempDiv.firstElementChild);
        }
      });

      self.config.cartItems.appendChild(wrapper);
    });

    // 3. Render standalone items
    standaloneItems.forEach((product) => {
      const preorderText = (this.PREORDER_STATUS && product.properties[this.preorderData.settings.cart.labelText.key])
        ? product.properties[this.preorderData.settings.cart.labelText.key] : null;

      self.config.cartItems.insertAdjacentHTML("beforeend", self.generateCartHtml(product, preorderText));
    });

    this.applyCartItemEventListeners();
  };

  waitForPlaceLayout = (maxWaitTime = 10000, checkInterval = 100) => {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();

      const checkAvailability = () => {
        if (this.charpstAR && typeof this.charpstAR.placeLayout === "function") {
          resolve();
        } else if (Date.now() - startTime >= maxWaitTime) {
          reject(new Error("placeLayout method did not become available within timeout"));
        } else {
          setTimeout(checkAvailability, checkInterval);
        }
      };

      checkAvailability();
    });
  };


  restoreTemporaryCartKeys = (temporaryCart) => {
    let tmpCartProducts = [];

    const schema = ["cop", "c", "did", "dpid", "fp", "iurl", "ipo", "mid", "n", "pmid", "p", "pid", "prop", "sp", "sku", "t", "vid", "bid", "bpid", "bp", "bpp", "bsp"];
    const restoredProducts = temporaryCart.d.map(row => {
      return schema.reduce((obj, key, index) => {
        let value = row[index];

        // Check if the current key is the image URL and prepend the base
        if (key === "iurl" && value) {
          value = '//' + temporaryCart.b + value;
        }

        obj[key] = value;
        return obj;
      }, {});
    });

    restoredProducts.forEach((product) => {
      tmpCartProducts.push({
        bundle_id: product.bid,
        bundle_product_id: product.bpid,
        bundle_price: product.bp,
        bundle_product_properties: product.bpp,
        bundle_selling_plan: product.bsp,
        compare_at_price: product.cop,
        count: 1,
        default_id: product.did,
        default_product_id: product.dpid,
        formattedPrice: product.fp,
        imageUrl: product.iurl,
        isPreorder: product.ipo,
        modulId: product.mid,
        name: product.n,
        parent_module_id: product.pmid,
        price: product.p,
        product_id: product.pid,
        properties: product.prop,
        selling_plan: product.sp,
        sku: product.sku,
        title: product.t,
        variant_id: product.vid,
      })
    })

    return tmpCartProducts;
  }
  copyTemporaryCartToCart = (temporaryCart) => {
    if (!temporaryCart) {
      return null
    }

    let tmpCartProducts = [];

    temporaryCart.forEach((product) => {
      tmpCartProducts.push({
        bundle_id: product.bundle_id,
        bundle_product_id: product.bundle_product_id,
        bundle_price: product.bundle_price,
        bundle_product_properties: product.bundle_product_properties,
        bundle_selling_plan: product.bundle_selling_plan,
        defaultId: product.default_id,
        defaultProductId: product.default_product_id,
        id: product.variant_id,
        isPreorder: product.isPreorder,
        modulId: product.modulId ?? null,
        parentModulId: product.parent_module_id ?? null,
        price: product.price,
        properties: product.properties,
        selling_plan: product.selling_plan,
        quantity: 1,
      })
    })

    return tmpCartProducts;
  }
  restoreSessionData = async (data = null, isParam = false) => {
    let cartProducts = null
    let layout = null
    let temporaryCart = null
    if (data) {
      cartProducts = data.cartProducts
      layout = data.layout
      temporaryCart = this.restoreTemporaryCartKeys(data.temporaryCart)
      cartProducts = this.copyTemporaryCartToCart(temporaryCart)
    } else {
      cartProducts = this.getItem("3d-products");
      layout = this.getItem("3d-layout");
      temporaryCart = this.getItem("3d-temporary-cart");
    }

    if (cartProducts && layout && temporaryCart) {
      let decodedCartProducts = null
      let decodedTemporaryCart = null
      let decodedLayout = null
      if (!isParam) {
        decodedCartProducts = this.decodeFromBase64(cartProducts);
        this.cartProducts = decodedCartProducts;

        decodedTemporaryCart = this.decodeFromBase64(temporaryCart);

        decodedLayout = this.decodeFromBase64(layout);
      } else {
        decodedCartProducts = cartProducts;
        this.cartProducts = cartProducts;

        decodedTemporaryCart = temporaryCart;

        decodedLayout = layout;
      }

      try {
        await this.waitForPlaceLayout();
        this.charpstAR.placeLayout(decodedLayout).then((r) => {
          this.temporaryCartProducts = decodedTemporaryCart;
          this.cartProducts = decodedCartProducts;
          this.recreateTemporaryCart(decodedTemporaryCart);

          this.cartProducts.forEach((cartProduct) => {
            if (cartProduct.parentModulId) {
              const childItem = this.config.cartItems.querySelector(
                '.cart-item[data-parent-modul-id="' + cartProduct.parentModulId + '"]',
              );
              if (childItem) {
                this.charpstAR.selectModelInScene(cartProduct.parentModulId);
                this.charpstAR.toggleMesh(childItem.dataset.sku, true);
              }
            }
          });

          this.calculateTotalPrice();
          this.updateShareButtonState();
        });
      } catch (error) {
        console.error("Failed to restore session data:", error);
      }
    }
  };

  clearSession = () => {
    localStorage.removeItem("3d-temporary-cart");
    localStorage.removeItem("3d-products");
    localStorage.removeItem("3d-layout");
  };

  saveToSession = (tmpCartProducts = null) => {
    let cartProducts = null;
    if (tmpCartProducts) {
      cartProducts = this.encodeToBase64(tmpCartProducts);
    } else {
      cartProducts = this.encodeToBase64(this.cartProducts);
    }
    const layout = this.encodeToBase64(this.charpstAR.getJsonData());
    const temporaryCart = this.encodeToBase64(this.temporaryCartProducts);

    this.setItem("3d-temporary-cart", temporaryCart, 1);
    this.setItem("3d-products", cartProducts, 1);
    this.setItem("3d-layout", layout, 1);
  };

  /**
   * Encodes data to Base64 string for localStorage
   * @param {*} data - Any JSON-serializable data
   * @returns {string} Base64 encoded string
   */
  encodeToBase64 = (data) => {
    try {
      const jsonString = JSON.stringify(data);
      // Use btoa for Base64 encoding
      return btoa(unescape(encodeURIComponent(jsonString)));
    } catch (error) {
      console.error("Error encoding to Base64:", error);
      throw error;
    }
  };

  /**
   * Decodes Base64 string from localStorage back to original data
   * @param {string} base64String - Base64 encoded string
   * @returns {*} Decoded data
   */
  decodeFromBase64 = (base64String) => {
    try {
      // Use atob for Base64 decoding
      const jsonString = decodeURIComponent(escape(atob(base64String)));
      return JSON.parse(jsonString);
    } catch (error) {
      console.error("Error decoding from Base64:", error);
      throw error;
    }
  };

  setItem = (key, value, expiryDays) => {
    const item = {
      value: value,
      expiry: Date.now() + expiryDays * 24 * 60 * 60 * 1000,
    };
    localStorage.setItem(key, JSON.stringify(item));
  };

  getItem = (key) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);

    if (Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  };

  /**
   * Removes all cart items that have a '_configurator' line item property
   * Uses Shopify's Cart API
   * @returns {Promise<Object>} Updated cart object
   */
  removeConfiguratorProducts = async () => {
    const response = await fetch("/cart.js");
    const cart = await response.json();

    // Build updates object - set quantity to 0 for items with _configurator property
    const updates = {};

    cart.items.forEach((item, index) => {
      // Line item properties are in item.properties
      if (item.properties && item.properties._configurator !== undefined) {
        // Use line item key for precise targeting
        updates[item.key] = 0;
      }
    });

    // Only make the request if there are items to remove
    if (Object.keys(updates).length > 0) {
      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      });

      return await updateResponse.json();
    }

    return cart;
  };

  generateShareLink = async () => {
    const layout = this.charpstAR.getJsonData();
    let temporaryCart = []
    const baseUrl = window.Shopify.cdnHost + "/shop/files/";
    const optimizedCart = {
      b: baseUrl,
      //s: ["cop", "c", "did", "dpid", "fp", "iurl", "ipo", "mid", "n", "pmid", "p", "pid", "prop", "sp", "sku", "t", "vid", "bid", "bpid", "bp", "bpp", "bsp"],
      d: this.temporaryCartProducts.map(p => [
        p.compare_at_price || 0, 1, Number(p.default_id), Number(p.default_product_id), p.formattedPrice,
        p.imageUrl.replace(baseUrl, "").split('?')[0], p.isPreorder ? 1 : 0, p.modulId, p.name, p.parent_module_id,
        p.price, Number(p.product_id), p.properties, p.selling_plan ?? null, p.sku, p.title, Number(p.variant_id), p.bundle_id ?? null, p.bundle_product_id ?? null, p.bundle_price ?? null, p.bundle_product_properties ?? null, p.bundle_selling_plan ?? null
      ])
    };

    const data = {
      layout: layout,
      temporaryCart: optimizedCart
    };

    const lib = JsonUrl('lzma');
    const output = await lib.compress(data);
    this.shareLink = output;

    const url = new URL(window.location.href);
    url.searchParams.set('config', this.shareLink);

    return url.toString();
  }

  /**
   * Checks if URL has a config parameter and decodes it
   * This reverses the process done in generateShareLink
   * @returns {Object|null} Decoded configuration object or null if not found/invalid
   */
  loadConfigFromURL = async () => {
    try {
      // Get URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      const configParam = urlParams.get('config');

      if (!configParam) {
        console.log('No config parameter found in URL');
        return null;
      }

      // Decompress the config parameter using LZString
      const lib = JsonUrl('lzma');
      const decompressedData = await lib.decompress(configParam);
      if (!decompressedData) {
        console.error('Failed to decompress config data');
        return null;
      }

      return decompressedData;
      /*
            // Parse the JSON data
            const data = JSON.parse(decompressedData);
      
            // Decode each component from Base64
            const decodedConfig = {
              cartProducts: data.cartProducts ? data.cartProducts : [],
              layout: data.layout ? data.layout : null,
              temporaryCart: data.temporaryCart ? data.temporaryCart : []
            };*/

      return decodedConfig;

    } catch (error) {
      console.error('Error loading config from URL:', error);
      return null;
    }

  }
  isItemBundleMatch = (item, bp, expectedColor, ignoreColor = false) => {
    if (ignoreColor) {
      return item.variant_id && bp.variant_id && String(item.variant_id) === String(bp.variant_id);
    }

    // 1. Direct variant match (if metafield naturally points to the exact variant)
    if (item.variant_id && bp.variant_id && String(item.variant_id) === String(bp.variant_id)) {
      if (expectedColor) {
        const itemColor = item.title ? item.title.split('/')[0].trim().toLowerCase() : '';
        if (itemColor !== expectedColor) return false;
      }
      return true;
    }

    // 2. Product ID + Color match (fallback for when config uses generic variant IDs e.g. variants[0].id)
    const itemColor = item.title ? item.title.split('/')[0].trim().toLowerCase() : '';
    if (expectedColor && expectedColor === itemColor) {
      const bpProductId = bp.product_id || bp.id;
      if (!bpProductId) return false;

      if (item.product_id && String(item.product_id) === String(bpProductId)) return true;
      if (item.default_product_id && String(item.default_product_id) === String(bpProductId)) return true;
      if (item.defaultId && String(item.defaultId) === String(bpProductId)) return true;
    }

    return false;
  }

  findMatchingBundles = () => {
    const matches = [];
    const unbundledItems = this.temporaryCartProducts.filter(p => !p.bundle_id);

    if (typeof fullBundles === 'undefined') return [];

    fullBundles.forEach(bundle => {
      if (!bundle.bundle_products || bundle.bundle_products.length === 0) return;

      const expectedColor = bundle.color ? bundle.color.toLowerCase().trim() : '';

      // Keep track of which specific items we are assigning to this bundle
      let matchedItemsForThisBundle = [];
      let tempAvailableItems = [...unbundledItems];
      let usedIgnoreColor = false;

      // Every bundle_product entry must have its variant/color requirements met
      const allMatch = bundle.bundle_products.every(bp => {
        const requiredQty = bp.quantity || 1;
        let foundQty = 0;

        // First pass: Try to find items matching both variant and color
        for (let i = tempAvailableItems.length - 1; i >= 0; i--) {
          const item = tempAvailableItems[i];

          if (this.isItemBundleMatch(item, bp, expectedColor, false)) {
            foundQty++;
            matchedItemsForThisBundle.push(tempAvailableItems.splice(i, 1)[0]);
            if (foundQty >= requiredQty) break;
          }
        }

        // Second pass: If not enough found, ignore color and just match by variant ID
        if (foundQty < requiredQty) {
          for (let i = tempAvailableItems.length - 1; i >= 0; i--) {
            const item = tempAvailableItems[i];

            if (this.isItemBundleMatch(item, bp, expectedColor, true)) {
              foundQty++;
              usedIgnoreColor = true;
              matchedItemsForThisBundle.push(tempAvailableItems.splice(i, 1)[0]);
              if (foundQty >= requiredQty) break;
            }
          }
        }

        return foundQty >= requiredQty;
      });

      if (allMatch) {
        // Use total required quantity as the priority score
        const totalQty = bundle.bundle_products.reduce((sum, bp) => sum + (bp.quantity || 1), 0);
        const priority = usedIgnoreColor ? 0 : 1;
        matches.push({ bundle, matchCount: totalQty, matchedItems: matchedItemsForThisBundle, priority });
      }
    });

    if (matches.length === 0) return null;

    // Sort descending — bundles requiring more items (e.g. 3+) take priority
    matches.sort((a, b) => {
      if (b.priority !== a.priority) {
        return b.priority - a.priority;
      }
      return b.matchCount - a.matchCount;
    });

    return matches; // Return the entire array of match objects
  }
}
